import { Navigate, useLocation } from "react-router-dom";
import { useU3148Context } from "../U3148Context";

const U3148RedirectToCurrentOrg: React.FC = () => {
  const { currentOrganizationId } = useU3148Context();
  const location = useLocation();

  // BL-0339 : pas d'écran vide si org absente de la session / initLU
  if (!currentOrganizationId) {
    return <Navigate to="/unauthorized" state={{ from: location.pathname }} replace />;
  }

  return <Navigate to={`/U3148/${currentOrganizationId}`} replace />;
};

export default U3148RedirectToCurrentOrg;
